import moment from 'moment';

export const convertDateWithTimezoneOffsetToEpoch = date => {
  const currentMoment = moment(date);
  const minutes = moment.parseZone(currentMoment).utcOffset();
  const currentMomentWithAddedTZOffset = currentMoment.add({minutes});

  return currentMomentWithAddedTZOffset.valueOf();
};

export const convertISOStringToDateWithTimezoneOffset = dateISO => {
  const currentMoment = moment(dateISO);
  const minutes = currentMoment.utcOffset();
  const currentMomentWithSubtractedTZOffset = currentMoment.subtract({minutes});

  return currentMomentWithSubtractedTZOffset.toDate();
};
